
import TagUser from "../../../assets/filled/TagUser.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TagUserIcon({ className, dataTestid = "TagUserIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TagUser data-testid={dataTestid} className={classes} {...rest} />
  );
}
